import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import "./styles.scss";

export const LinkTypes = {
  link: "apti-Link",
  linkV2: "apti-LinkV2",
  linkV2NoUnderline: "apti-LinkV2-no_underline",
};

export const Link = ({ children, className, href, onClick, target, type, ...props }) => (
  <a
    className={createClassNameString(["apti-CL", type, className])}
    href={href}
    onClick={onClick}
    target={target}
    {...props}
  >
    {children}
  </a>
);

Link.propTypes = {
  children: PropTypes.oneOf([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  target: PropTypes.string,
  type: PropTypes.oneOf(["apti-Link", "apti-LinkV2", "apti-LinkV2-no_underline"]),
};

Link.defaultProps = {
  children: "",
  className: undefined,
  href: "",
  onClick: () => {},
  target: "_blank",
  type: LinkTypes.link,
};
